// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"iR-z","categoryName":"jR-z","categoryNameSearchHeader":"kR-z","categoryContent":"lR-z","bottomAligned":"mR-z","image":"nR-z","imageNoBackground":"oR-z"};